// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rXlWP","left":"styles_left__sdcLP","visibleContent":"styles_visibleContent__UOeIS","openContentButton":"styles_openContentButton__ifKYC"};